import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3a9ee432"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_2 = { class: "header__nav-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__bg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavItems = _resolveComponent("NavItems")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppDrawer = _resolveComponent("AppDrawer")!
  const _component_AppRequestForm = _resolveComponent("AppRequestForm")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", { 'is-hidden': _ctx.headerHidden }])
  }, [
    _createVNode(_component_router_link, {
      class: "header__logo-wrapper",
      to: "/"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("i", {
      class: "header__show-items-icon ct-icon-list",
      role: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNavItems = true))
    }),
    _createVNode(_component_AppDrawer, {
      visible: _ctx.showNavItems,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNavItems = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NavItems),
        _createVNode(_component_AppButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true)),
          theme: "dark"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Начать проект ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavItems),
      _createVNode(_component_AppButton, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Начать проект")
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _createVNode(_component_AppDialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AppRequestForm, { class: "header__request-form" })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}